<template>
    <ion-page class="no-padding-top">
        <ion-loading
            :is-open="RS_loader.global"
            :message="RS_loader.globalMessage"
        />
        <ion-header :translucent="false">
            <ion-toolbar class="no-border" :class="{impersonationWarning: showImpersonationWarning}">
<!--                <ion-button-->
<!--                    color="secondary"-->
<!--                    fill="clear"-->
<!--                    v-on:click="router.go(-1)"-->
<!--                    size="small"-->
<!--                >-->
<!--                    <ion-icon slot="icon-only" src="/icons/caret-left.svg" />-->
<!--                </ion-button>-->
<!--                <ion-title>Assistent</ion-title>-->
                <ion-buttons slot="start">
                    <ion-button
                        v-if="RS_show.ainesHomeButton"
                        color="secondary"
                        fill="clear"
                        @click="resetConversation()"
                        class="has-badge"
                    >
                        <ion-icon slot="icon-only" src="/icons/house.svg" />
                        <ion-badge v-if="RS_show.ainesObjectiveBadge && aInesObjectiveStore.unhandledObjectivesLength">!</ion-badge>
                    </ion-button>
                </ion-buttons>
                <ion-buttons slot="end">
                    <!--<ion-button
                        color="secondary"
                        fill="clear"
                        v-on:click="aInesObjectiveStore.toggleUIState"
                        class="image-icon has-badge"
                    >
                        <img slot="icon-only" src="/logo.png" />
                        
                    </ion-button>-->

                    <ion-button
                        v-if="RS_show.calendarButton"
                        color="secondary"
                        fill="clear"
                        v-on:click="calendarModalOpen = true"
                        data-cy="button calendar"
                    >
                        <ion-icon slot="icon-only" src="/icons/calendar-blank.svg" />
                    </ion-button>
                    <ion-button
                        color="secondary"
                        fill="clear"
                        v-if="authStore.isUserRole('employee') || authStore.isImpersonating()"
                        v-on:click="employeeSedCardModalOpen = true"
                        class="profile-button has-badge"
                    >
                        <img v-if="employee?.profilePicturePath" :src="employee?.profilePicturePath" alt="Profilbild"/>
                        <ion-icon v-else slot="icon-only" :src="KapitelIcon.employeePictureMissing" />

                        <IonBadge v-if="!employee?.sedCardSufficientlyFilled"></IonBadge>
                    </ion-button>
                    <ion-button
                        v-if="authStore.isImpersonating()"
                        color="secondary"
                        fill="clear"
                        v-on:click="useAppState().stopImpersonation()"
                        class="impersonation"
                    >
                        <ion-icon slot="icon-only" src="/icons/detective.svg" />
                        <ion-label>{{ employeeName }}</ion-label>
                    </ion-button>
                </ion-buttons>

            </ion-toolbar>
        </ion-header>
        <ion-content>

            <AInesObjectivesList
                v-if="RS_show.ainesObjectiveList"
                v-on:objective:click="onAInesObjectiveSelect"
                :blur="!!RS_show.quickChats"
            />
            <!--<Transitionator :types="['opacity', 'scale']" :module-options="{scale: {base: 0.8}}" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="150">
                <AInesObjectivesList
                    v-on:avatar:click="onAInesObjectiveAvatarClick"
                    v-on:objective:click="onAInesObjectiveSelect"
                />
            </Transitionator>-->
            <div class="chat-container">
                <div class="response-container">

                    <!-- VOICE OR TEXT MODE -->
                    <Transitionator :types="['opacity', 'margintop']" easing-enter="easeOutBounce" easing-leave="easeInBounce">
                        <AInesVoiceAvatar
                            v-if="RS_show.voiceMode && !RS_show.ainesObjectiveList"
                        />
                    </Transitionator>
                    <Transitionator :types="['opacity', 'margintop']" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="150">
                        <AInesMessage
                            v-if = "RS_show.textMode && (RS_show.messageText || RS_show.messageLoaderMessage)"
                            :text-content="RS_assistantMessage?.textContent || ''"
                            />
                    </Transitionator>

                    <Transitionator :types="['opacity', 'margintop']" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="10">
                        <AInesMessage
                            v-if = "RS_show.messageLoaderDots || RS_show.richResponseLoaderDots"
                            :text-content="''"
                            :show-pending="true"
                        />
                    </Transitionator>
                    <div
                        v-if="RS_show.messageRichResponses && RS_assistantMessage?.richContents"
                        v-for="richContent in RS_assistantMessage.richContents"
                        class='rich-response-container'
                    >
                        <Transitionator v-if="!!getRichComponentFor(richContent)" :types="['opacity', 'scale']" :module-options="{scale: {base: 0.8}}" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="20">
                            <div>
                                <component
                                    :is="getRichComponentFor(richContent)"
                                    :init-data="richContent.initData"
                                />
    <!--                                @blockprompt="onRichComponentBlockPrompt"-->
    <!--                                @unblockprompt="onRichComponentUnblockPrompt"-->
    <!--                                @sendmessage="onRichComponentSendMessage"-->
                            </div>
                        </Transitionator>
                    </div>
                </div>
            </div>
            <CalendarDetail v-if="dayDetailModalOpen" v-model="clickedDate" :date-id="clickedDate"></CalendarDetail>
            <CalendarModal
                v-model="calendarModalOpen"
                :initial-date="today"
                :showPlanningStatus="true"
            />
            <EmployeeSedCardModal
                v-model="employeeSedCardModalOpen"
            />
        </ion-content>

        <ion-footer class="footer-input">

            <!-- chat input -->
            <div
                class="chat-input-container">
                <Transitionator :types="['opacity', 'scale']" :module-options="{scale: {base: 0.8}}" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="50">
                    <ChatInput
                        ref="chatInputRef"
                        v-if="chatStore.isTextMode"
                        v-on:text:submit="onChatInputSubmit"
                        v-on:text:input="onChatInputTextInput"
                        v-on:text:paste="onChatInputTextPaste"
                        v-on:focusin="chatInputFocused = true"
                        v-on:focusout="handleFocusOut"
                        :disabled="RS_loader.setup"
                    />
                </Transitionator>
                <Transitionator :types="['opacity', 'scale']" :module-options="{scale: {base: 0.8}}" easing-enter="easeOutBounce" easing-leave="easeInBounce" :duration-leave="50">
                    <VoiceInput
                        v-if="chatStore.isVoiceMode"
                        v-on:text:submit="(message) => chatSendsNewUserMessage(message)"
                        :disabled="RS_loader.setup"
                    />
                </Transitionator>
                <ion-button
                    v-on:click="onToggleVoiceTextMode"
                    color="white"
                    class="floating-big-pseudo floating"
                    :disabled="RS_loader.setup"
                >
                    <ion-icon
                        slot="icon-only"
                        color="primary"
                        :src="chatStore.isVoiceMode ? '/icons/x.svg' : '/icons/microphone.svg'"
                    />
                </ion-button>
            </div>

            <!-- quick chat -->
            <div v-if="RS_show.quickChats" class="quick-access-buttons" :class="{'centered': chatStore.isVoiceMode}">
                <template v-if="RS_show.quickChats === 'main'">
                    <div v-for="qc in RS_mainMenuQuickChats" :key="qc.label" class="quick-access-item">
                        <div class="floating-big-pseudo" @click="qc.click">
                            <IonIcon :icon="qc.icon || ''"></IonIcon>
                            {{ qc.label }}
                        </div>
                        <NewBadge v-if="qc.new"/>
                    </div>

                    <div class="quick-access-spacer" />

                </template>

                <div v-for="qc in RS_quickChats?.toReversed() ?? []" :key="qc.label" class="quick-access-item">
                    <div class="floating-big-pseudo" @click="qc.click">
                        <IonIcon :icon="qc.icon || ''"></IonIcon>
                        {{ qc.label }}
                    </div>
                </div>
            </div>
        </ion-footer>
    </ion-page>
</template>

<script setup lang="ts">
import {
    IonBadge,
    IonButton,
    IonButtons,
    IonContent,
    IonFooter,
    IonHeader,
    IonIcon,
    IonLabel,
    IonLoading,
    IonPage,
    IonToolbar,
    IonChip
} from "@ionic/vue";
import ChatInput from '@/views/Chat/ChatInput.vue'
import VoiceInput from '@/views/Chat/VoiceInput.vue'
import {computed, ComputedRef, Ref, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {
    ExploreQuickChat, exploreQuickChatMainMenuItems,
    getExploreQuickChatsMatching,
    getExploreQuickChatsTopN,
    useExploreQuickChatStore
} from "@/helper/chat/exploreQuickChats";

import {PreprocessedAssistantMessage, useChatStore} from "@/helper/chat/chatStore";
import {resetConversation, sendUserMessage, setUpAssistant, setUpAssistantDone} from "@/helper/chat/chatBL";
import {AInesAssistantType, AInesObjective, AInesRichResponseType} from "@/graphql/generated/graphql";
import {getRichComponentFor, RichContent} from "@/helper/chat/richResponses";
import Transitionator from "../components/transitions/Transitionator.vue";
import {ChatStatus} from "@/helper/chat/chatStatus";
import {requireAssistentForFeatureSet} from "@/helper/chat/assistantFeatureMapping";
import {consoleErrorChat} from "@/helper/console";
import CalendarDetail from "@/views/CalendarDetail/CalendarDetail.vue";
import {useAuthStore} from "@/store/auth";
import {kapitelDateString} from "@/graphql/kapitelTypes";
import {useGlobalEmitter} from "@/helper/emitter";
import CalendarModal from "@/views/Calendar/CalendarModal.vue";

import AInesVoiceAvatar from "@/views/Chat/AInesVoiceAvatar.vue";
import date from "@/helper/datetime/date";
import {homeOutline} from "ionicons/icons";
import {useEmployeeStore} from "@/store/employee";
import {useCandidateStore} from "@/store/candidate";
import AInesMessage from "@/views/Chat/AInesMessage.vue";
import {ClickableQuickChat, QuickChat} from "@/helper/chat/quickChat";
import {ScriptedQuickChat} from "@/helper/chat/scriptedMessage";
import {fuzzyLinkParsing, relogByChatInput} from "@/helper/auth";
import {useAppState} from "@/helper/appState";

import {handleObjectiveClick, useAInesObjectiveStore} from "@/helper/chat/ainesObjectives";
import AInesObjectivesList from "@/views/Chat/AInesObjectivesList.vue";
import EmployeeSedCardModal from '@/views/Employees/EmployeeSedCardModal.vue'
import {onMonthKPIDetailRequest} from "@/helper/notification";
import {isUndefined} from "@/helper/isset";
import {computedAsync} from "@vueuse/core";
import NewBadge from "@/components/NewBadge.vue";
import {env} from "@/helper/env";
import {KapitelIcon} from "@/helper/icon";

/*
init
 */

const chatInputRef : Ref<typeof ChatInput | undefined> = ref(undefined)
const chatInputFocused = ref(false)

const router = useRouter();
const chatStore = useChatStore();
const authStore = useAuthStore();

const aInesObjectiveStore = useAInesObjectiveStore();
const blockButtonLabel = ref()

const onToggleVoiceTextMode = () => {
    if(chatStore.voiceOrTextMode == "text"){
        chatStore.setVoiceOrTextMode("voice")
    }else{
        chatStore.setVoiceOrTextMode("text")
    }
}

const handleFocusOut = () => {
    // wait for all click events to be processed
    setTimeout(
        ()=>chatInputFocused.value = false,
        100
    )
}

const employee= computed(() => useEmployeeStore().storedEmployee)

const employeeName : ComputedRef<string> = computed(() => {
    const parts = employee.value?.name?.split(' ')

    if (parts && parts[0]) {
        return parts[0]
    }

    if (employee.value?.name) {
        return employee.value?.name
    }

    return '?'
})

const showImpersonationWarning = computed(() => authStore.isImpersonating() && !employee.value?.demo && env.isProduction())

const calendarModalOpen = ref(false)
const employeeSedCardModalOpen = ref(false)

const dayDetailModalOpen = ref(false)
const clickedDate: Ref<kapitelDateString|undefined> = ref(undefined)

const gEmitter = useGlobalEmitter()

gEmitter.on('notification:date:clicked', (dateId: kapitelDateString) => {
    console.log("clicked on notification with date: " + dateId)
    clickedDate.value = dateId
    dayDetailModalOpen.value = true
});

gEmitter.on('notification:month:clicked', (monthId: kapitelDateString) => {
    console.log("clicked on notification with month: " + monthId)
    onMonthKPIDetailRequest(monthId)
});


const checkForMagicLink = (message: string) : boolean => {
    const parsed = fuzzyLinkParsing(message);
    if(parsed !== ""){
        relogByChatInput(message).then(() => {
            if (useAppState().isEmployeeOrCandidate('employee') || useAppState().isEmployeeOrCandidate('candidate')) {
                resetConversation()
            }
        })

        return true
    }
    return false
}

const chatSendsNewUserMessage = async (
    message: string,
    options: {
        messageExpertAssistant?: AInesAssistantType,
        prependedAssistantMessage?: string,
        prependExpertAssistant?: AInesAssistantType,
        richContentsPreview?: RichContent[],
        isScriptedContent?: boolean,
    } = {
        messageExpertAssistant: undefined,
        prependedAssistantMessage: undefined,
        prependExpertAssistant: undefined,
        richContentsPreview: undefined,
        isScriptedContent: false
    }
) : Promise<void> => {
    
    // TODO: centralize prepend 3
    const chatStore = useChatStore()
    if (!options.prependedAssistantMessage && chatStore.scriptedMessage) {
        if(options.prependExpertAssistant){ // only add assistant message if expert assistant is given
            options.prependedAssistantMessage = chatStore.scriptedMessage.textContent
        }
    }


    return await sendUserMessage(
        message,
        {
            messageExpertAssistant: options.messageExpertAssistant,
            prependedAssistantMessage: options.prependedAssistantMessage,
            prependExpertAssistant: options.prependExpertAssistant,
            richContentsPreview: options.richContentsPreview,
            isScriptedContent: options.isScriptedContent
        }
    )
}

/*
TopSheet Handling
 */

const processes: AInesRichResponseType[] = [
    AInesRichResponseType.RegisterBookingSummary,
    AInesRichResponseType.AutopilotStartWizard,
    AInesRichResponseType.JobsiteSearch
]

const currentModalSelection : Ref<RichContent|undefined> = ref(undefined);
const processModalOpen = ref(false)
const onClickRichResponse = (content: RichContent)=>{
    if(processes.indexOf(content.type as AInesRichResponseType)>-1){
        currentModalSelection.value = content
        processModalOpen.value = true
    }
}


/*
rendersets
 */

const today = date.getToday()

const RS_loader = computed(() => ({
    global: !!chatStore.globalLoaderState,
    globalMessage: chatStore.globalLoaderState,
    setup: !setUpAssistantDone.value
}))

const RS_show = computed(() => {
    const s = chatStore.chatStatus

    const show = {
        voiceMode: chatStore.voiceOrTextMode == "voice",
        textMode: chatStore.voiceOrTextMode == "text",

        // default: no loader shown
        messageLoaderDots: false,
        messageLoaderMessage: false,
        richResponseLoaderDots: false,

        // default: no message content shown
        messageText: false,
        messageRichResponses: false,

        // other modules
        ainesHomeButton: true,
        ainesObjectiveBadge: false,
        ainesObjectiveList: false,

        // exploreQuickChats: false,
        // responseQuickChats: false,
        quickChats: false as 'main' |'searchstring' | 'requestResponse' | 'scripted' | false ,

        calendarButton: true
    }

    // TODO: role handling
    if (useAppState().isEmployeeOrCandidate('candidate') && !useCandidateStore().isPromoted) {
        show.calendarButton = false
    }


    if(chatStore.nothingHappenedYet){
        show.ainesHomeButton = false
    }
    if(chatStore.nothingHappenedYet && !chatStore.scriptedMessage){
        show.ainesObjectiveList = true
    }
    show.ainesObjectiveBadge = !show.ainesObjectiveList;

    // message, loader & rich response - only if request summary not open
    if (aInesObjectiveStore.selection) {
        // selection always trumps regular message
        show.messageText = true
        show.messageRichResponses = true
        show.quickChats = 'requestResponse'
    } else if(chatStore.scriptedMessage) {
        show.messageText = true
        show.messageRichResponses = true
        show.quickChats = 'scripted'
    } else {
        if (chatStore.currentExpertRunMessageRichContentsPreview) {
            show.messageRichResponses = true
        }

        switch (true) {
            case (s === ChatStatus.READY):
                break;
            case (s === ChatStatus.FAILED):
                break
            case (s === ChatStatus.EXPECTING_NEXT_RESPONSE):
            case (s === ChatStatus.PREPENDING_ASSISTANT_MESSAGE):
            case (ChatStatus.isChoosing(s)):
            case (s === ChatStatus.EXPERT_SETUP):
            case (ChatStatus.isExperting(s) && s !== ChatStatus.EXPERT_RESPONDING):
                // run in preparation, choosing, or pending -> loader dots
                show.messageLoaderDots = chatStore.voiceOrTextMode=="text";
                break;
            case (s === ChatStatus.EXPERT_RESPONDING):
                // expert run pending - differentiate in reverse order: waiting, toolcalls, text streaming, tool call streaming, done
                const recentToolCall = chatStore.currentExpertRunMostRecentToolCall
                const recentMessageStatus = chatStore.currentExpertRunMessageStatus

                if (recentMessageStatus === 'messageDone') { // done
                    show.messageText = true
                    show.messageRichResponses = true
                } else if (recentMessageStatus === 'textDone') { // tool call streaming
                    show.messageText = true
                    if (!show.messageRichResponses) {
                        show.richResponseLoaderDots = true // text is done streaming, but message not - we may be waiting for RRs
                    }
                } else if (recentMessageStatus === 'streaming') { // text streaming
                    show.messageText = true
                }else if (recentToolCall) { // tool calls
                    show.messageLoaderMessage = true
                } else { // waiting
                    show.messageLoaderDots = chatStore.voiceOrTextMode=="text"
                }
                break;
            case (s === ChatStatus.EXPERT_COMPLETE):
                show.messageText = true
                show.messageRichResponses = true

                if (chatStore.scriptedQuickChats) {
                    show.quickChats = 'scripted'
                }

                break;
            default:
                consoleErrorChat('unhandled Chat.vue status for %o', s)
                break;
        }

        if (
            chatStore.nothingHappenedYet &&
            !aInesObjectiveStore.selection &&
            chatInputFocused.value &&
            // !show.ainesObjectiveSummary &&
            !chatStore.isBlocked &&
            setUpAssistantDone.value
        ) {
            if (quickChatSearchStringSet.value) {
                show.quickChats = 'searchstring'
            } else {
                show.quickChats = 'main'
            }
        }
    }

    return show
})

const RS_assistantMessage: Ref<PreprocessedAssistantMessage | undefined> = computed(() => {

    let message = undefined

    if (chatStore.currentExpertRunMessageTextStreaming || chatStore.currentExpertRunMessageRichContents || chatStore.currentExpertRunMessageRichContentsPreview || chatStore.currentExpertRunMostRecentToolCallLoaderMessage) {
        message = {
            textContent: chatStore.currentExpertRunMessageTextStreaming || chatStore.currentExpertRunMostRecentToolCallLoaderMessage || undefined,
            richContents: chatStore.currentExpertRunMessageRichContents || chatStore.currentExpertRunMessageRichContentsPreview || undefined
        }
    } else if (chatStore.scriptedMessage){
        message = chatStore.scriptedMessage
    } else if (chatStore.currentExpertRunMostRecentToolCallLoaderMessage) {
        message = {
            textContent: chatStore.currentExpertRunMostRecentToolCallLoaderMessage,
            richContents: undefined
        }
    }
    
    return message
})

const RS_mainMenuQuickChats: ComputedRef<ClickableQuickChat[]> = computed( () => {
    switch (RS_show.value.quickChats) {
        case 'main': return exploreQuickChatMainMenuItems.value
            .map(makeExploreQuickChatClickable)
        default: return [] as ClickableQuickChat[]
    }
})

const RS_quickChats: Ref<ClickableQuickChat[]> = computed(() => {
    switch (RS_show.value.quickChats) {
        // case 'requestResponse': return requestResponseQuickChats.value
        case 'scripted': return scriptedQuickChats.value
        case 'searchstring': return quickChatsForSearchString.value.map(makeExploreQuickChatClickable)
        case 'main': return getExploreQuickChatsTopN(3).map(makeExploreQuickChatClickable)
        default: return []
    }
})


/**
 * chat input
 */

const chatInputText = ref('')
const onChatInputTextInput = (text: string) => {
    chatInputText.value = text
}
const onChatInputTextPaste = (text: string) => {
    if (checkForMagicLink(text)) {
        chatInputRef.value?.clear()
    }
}
const onChatInputSubmit = (message: string) => {
    if (checkForMagicLink(message)) {
        chatInputRef.value?.clear()
        return
    }

    chatSendsNewUserMessage(message)
}

/*
ExploreQuickActions
 */

const makeExploreQuickChatClickable = (qc:ExploreQuickChat) => ({...qc, click: () => clickExploreQuickChat(qc)})

const quickChatSearchString : ComputedRef<string|undefined> = computed(() => chatInputText.value.trim() || undefined)
const quickChatSearchStringSet = computed(() => !isUndefined(quickChatSearchString.value))
const quickChatsForSearchString : Ref<ExploreQuickChat[]> = computed(() =>
    quickChatSearchStringSet.value
        // show top 5 matches for search string
        ? getExploreQuickChatsMatching(chatInputText.value.trim(), 3)
        : []
)


const clickExploreQuickChat = async (qc:ExploreQuickChat) => {

    const expertAssistant = (qc.featureSet ? await requireAssistentForFeatureSet(qc.featureSet) : qc.expertAssistant) || undefined

    chatSendsNewUserMessage(
        qc.prompt ?? qc.label,
        {
            messageExpertAssistant: expertAssistant,
            richContentsPreview: qc.richContentsPreview || undefined,
            isScriptedContent: true
        }
    )

    useExploreQuickChatStore().trackUsage(qc)

    chatInputRef.value?.clear()
}



/*
AInesRequests & responseQuickActions
 */

// // init AInesRequests
// aInesObjectiveStore.setUIState(AInesObjectiveUIState.MINIMIZED)
//
// // trigger fetch for new requests
// let aInesObjectiveInitialAutoOpened = false
// const aInesObjectiveInit = () => {
//     aInesObjectiveStore
//         .refetch()
//         .then(() => {
//             // show objectives automatically - only if nothing happened yet
//             if (
//                 aInesObjectiveStore.objectivesLength > 0 &&
//                 chatStore.nothingHappenedYet
//             ) {
//                 aInesObjectiveInitialAutoOpened = true
//                 aInesObjectiveStore.setUIState(AInesObjectiveUIState.VISIBLE)
//             }
//         });
// }
// aInesObjectiveInit()
// useGlobalEmitter().on("AppStateChanged", ({state, impersonationUserSwitch}) => {
//     if (state === 'employee' && impersonationUserSwitch) {
//         aInesObjectiveInit()
//     }
// })

// // close again if automatically opened
// watch(() => chatStore.nothingHappenedYet, () => {
//     if (aInesObjectiveInitialAutoOpened) {
//         aInesObjectiveStore.setUIState(AInesObjectiveUIState.MINIMIZED)
//     }
// })

// const onAInesObjectiveAvatarClick = () => aInesObjectiveStore.setUIState(AInesObjectiveUIState.MINIMIZED)
const onAInesObjectiveSelect = (objective: AInesObjective) => {
    // aInesObjectiveStore.setUIState(AInesObjectiveUIState.MINIMIZED)
    aInesObjectiveStore.selectObjective(objective)
    handleObjectiveClick(objective)
}


const scriptedQuickChats : ComputedRef<ClickableQuickChat[]> = computed(() => {
    if (chatStore.scriptedMessage) {
        return (chatStore.scriptedMessage?.suggestedQuickChats || []) as ScriptedQuickChat[]
    }
    if (chatStore.scriptedQuickChats) {
        return chatStore.scriptedQuickChats
    }
    return []
})

if (!window.DEBUG.SKIP_SETUP_ASSISTANT) {
    setUpAssistant()
}
</script>

<style scoped lang="scss">

.chat-container{
    margin-bottom: 5em;
    width: 100%;
    position: relative;
}
.response-container {
    display: flex;
    flex-direction: column;
    color: black;
    align-items: flex-start;
}

.chat-input-container {
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    position: relative;

    > * {
        min-height: 3.6rem;
    }

    > .chat-text-input {
        flex: 1 1 auto;
        margin-right: 0.5rem;
        order: 1;
    }

    > ion-button {
        background-color: var(--ion-color-white);
        flex: 0 0 3.6em;
        width: 3.6rem;
        border-radius: 1em;
        margin-left: 0.5rem;
        margin-top: 0;
        margin-bottom: 0;
        order: 2;

        ion-icon {
            font-size: 1.5rem;
        }
    }
}

.rich-response-container{
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;

    &:not(:last-child) {
        margin-bottom: 0.5em;
    }

    > *:not(:last-child) {
        margin-bottom: 0.5em;
    }
}

.system-message {
    align-self: flex-start;
}

.user-message {
    align-self: flex-end;
}

.footer-input {
    width: 100%;
    padding-left: var(--custom-spacing-app-content-padding-horizontal);
    padding-right: var(--custom-spacing-app-content-padding-horizontal);
    padding-bottom: calc(var(--ion-safe-area-bottom) + var(--custom-spacing-app-content-padding-vertical));
    padding-top: var(--custom-spacing-app-content-padding-vertical);

    display: flex;
    flex-direction: column;

    > ion-input {
        z-index: 1;
    }
}

.quick-access-buttons {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    top: 0.5em;
    right: var(--custom-spacing-app-content-padding-horizontal);
    left: var(--custom-spacing-app-content-padding-horizontal);
    transform: translateY(-100%);
    transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    > .quick-access-spacer {
        height: 1em;
    }

    > .quick-access-item {
        display: flex;
        justify-content: center;
        width: 100%;

        :deep(ion-icon) {
            font-size: 1.2em;
            display: inline-block;
            vertical-align: text-bottom;
            margin-right: 0.5rem;
        }

        &:not(:last-child) {
            margin-bottom: 0.5em;
        }

        > div {
            flex: 0 0 auto;
            display: inline-block;
            font-size: var(--custom-font-size-small);
            color: var(--ion-color-black);
            padding: 0.9em 1.5em;
            border-radius: 1rem;
            background-color: var(--ion-color-white);
        }

        &:after {
            content: '';
            flex: 1;
            transition: flex 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        &:nth-child(1):after { transition-delay: 0.02s; }
        &:nth-child(2):after { transition-delay: 0.04s; }
        &:nth-child(3):after { transition-delay: 0.06s; }
        &:nth-child(4):after { transition-delay: 0.08s; }
        &:nth-child(5):after { transition-delay: 0.10s; }
        &:nth-child(6):after { transition-delay: 0.12s; }
        &:nth-child(7):after { transition-delay: 0.14s; }
        &:nth-child(8):after { transition-delay: 0.16s; }
        &:nth-child(9):after { transition-delay: 0.18s; }
    }

    &.centered {
        top: -0.5em;
        align-items: center;

        > .quick-access-item {
            &:after {
                flex: 0;
            }
        }
    }
}

.impersonation ion-label {
    margin-left: 0.25em;
}

ion-toolbar.impersonationWarning {
    --ion-toolbar-background: var(--ion-color-red);
    --border-width: 0;

    &, * {
        color: var(--ion-color-white);
    }
}

.profile-button {
    img {
        --SIZE: 1.7em;
        width: var(--SIZE);
        height: var(--SIZE);
        border-radius: var(--SIZE);
        overflow: hidden;
        object-fit: cover;
    }
    ion-icon {
        --SIZE: 1em;
        width: var(--SIZE);
        height: var(--SIZE);
    }
}
</style>
